import { buildMesUrl, mesHttp } from '@shared/api/mesClient';
import type { AuthHeaders } from '@shared/api/httpClient';
import type {
  HelpCatalogResponse,
  HelpPageResponse,
  GuideScreenshotManifest,
  HelpSearchResponse,
  HelpTourResponse,
  HelpToursResponse
} from '../types';

export const fetchHelpCatalog = async (headers: AuthHeaders) => {
  const response = await mesHttp.get<HelpCatalogResponse>(buildMesUrl('/help/catalog'), { headers });
  return response.data;
};

export const fetchHelpPage = async (key: string, headers: AuthHeaders) => {
  const response = await mesHttp.get<HelpPageResponse>(buildMesUrl(`/help/pages/${encodeURIComponent(key)}`), {
    headers
  });
  return response.data.page;
};

export const searchHelp = async (
  params: {
    q?: string;
    page?: number;
    limit?: number;
  },
  headers: AuthHeaders
) => {
  const response = await mesHttp.get<HelpSearchResponse>(
    buildMesUrl('/help/search', {
      q: params.q,
      page: params.page ? String(params.page) : undefined,
      limit: params.limit ? String(params.limit) : undefined
    }),
    { headers }
  );
  return response.data;
};

export const fetchHelpTours = async (headers: AuthHeaders) => {
  const response = await mesHttp.get<HelpToursResponse>(buildMesUrl('/help/tours'), { headers });
  return Array.isArray(response.data?.tours) ? response.data.tours : [];
};

export const fetchHelpTour = async (key: string, headers: AuthHeaders) => {
  const response = await mesHttp.get<HelpTourResponse>(buildMesUrl(`/help/tours/${encodeURIComponent(key)}`), {
    headers
  });
  return response.data.tour;
};

export const fetchHelpScreenshot = async (scenarioKey: string, captureKey: string, headers: AuthHeaders) => {
  const response = await mesHttp.get<{ screenshot: GuideScreenshotManifest }>(
    buildMesUrl(`/help/screenshots/${encodeURIComponent(scenarioKey)}/${encodeURIComponent(captureKey)}`),
    { headers }
  );
  return response.data.screenshot;
};

export const fetchHelpScreenshotMedia = async (mediaUrl: string, headers: AuthHeaders) => {
  const response = await mesHttp.get<Blob>(buildMesUrl(mediaUrl), {
    headers,
    responseType: 'blob'
  });
  return response.data;
};
